export function createEvent(eventName, detail = {}, original = null, cancelable = false) {
    return new CustomEvent(eventName, { bubbles: true, composed: true, cancelable, detail: Object.assign(Object.assign({}, detail), { original }) });
}
export function debounce(callback, timer) {
    let timeout = null;
    return function (...args) {
        timeout && window.clearTimeout(timeout);
        timeout = window.setTimeout(callback, timer, ...args);
    };
}
export function throttle(callback, timer) {
    let throttled = false;
    return function (...args) {
        if (!throttled) {
            throttled = true;
            window.setTimeout(() => throttled = false, timer);
            callback(...args);
        }
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function throttleAndDebounce(callback, throttleTimer = 100, debounceTimer = 50) {
    const throttledCallback = throttle(callback, throttleTimer);
    const debouncedCallback = debounce(callback, debounceTimer);
    return function (...args) {
        throttledCallback(...args);
        debouncedCallback(...args);
    };
}
//# sourceMappingURL=events.js.map